import { DataGrid, Form } from "devextreme-react";
import { Column, CustomRule, Editing, FormItem, GroupItem, KeyboardNavigation, Lookup, PatternRule, Popup, RequiredRule } from "devextreme-react/data-grid";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import './profile.scss'
import { useDataSource } from "../../../contexts/dataSource";
import { useAuth } from "../../../contexts/auth";
import { getPropsDataGrid, getPropsDataGridEditing, getPropsDataGridPopup } from "../../../utils/default-props";
import { useScreenSize } from "../../../utils/media-query";
import { getDataGridCustomToolbar } from "../../../components/default-components/data-grid-custom-toolbar";
import BankInfoPopup from "../management/settings/bank-info-popup";
import { useLookupGroup } from "../../../contexts/lookup-group-context";
import { lookupGroups } from "../../../utils/lookup-groups.ts";
import IBAN from "iban";



let dbBankSelectBoxRef;

function Bank({ employeeId }) {

    const refGrid = useRef()
    const { dataSourceHR } = useDataSource()
    const { user, activeLanguage } = useAuth()
    const [sizeParam, setSizeParam] = useState({})
    const { isLarge, isMedium } = useScreenSize();
    const { getLookupData } = useLookupGroup()

    const [bankInfoPopupVisible, setBankInfoPopupVisible] = useState(false)
    const [bankAccountTypeList, setBankAccountTypeList] = useState()

    const [refreshGrid, setRefreshGrid] = useState(false)
    /*****************/
    // burası örnek olarak kalsın, kayıt sırasında listeye ekleme yapmak için tasarımlar mevcut
    /*****************/
    const dataSource = useMemo(() => dataSourceHR({
        loadUrl: `/api/EmployeeBank/Employee/${employeeId}`,
        insertUrl: "/api/EmployeeBank/FormData"
    }), [user, employeeId])

    const dbBank = useMemo(() => dataSourceHR({
        loadUrl: "/api/BankInfo"
    }), [])

    const handleInitNewRow = useCallback((e) => {
        e.data.employeeId = employeeId
        e.data.active = true
    }, [employeeId])

    const accountTypeEditorOption = {
        items: bankAccountTypeList,
        valueExpr: "id",
        displayExpr: "text",
    }

    const handleInitializedBankSelectbox = (e) => {
        dbBankSelectBoxRef = e.component.instance().getDataSource()

    }

    const addBank = (e) => {
        setBankInfoPopupVisible(true)
        setRefreshGrid(true)
    }

    const bankInfoEditorOptions = {
        dataSource: dbBank,
        valueExpr: "id",
        displayExpr: "name",
        onInitialized: handleInitializedBankSelectbox,
        buttons: [
            "dropDown",
            {
                name: 'add1',
                location: 'after',
                options: {
                    stylingMode: 'text',
                    icon: 'plus',
                    onClick: addBank,
                },
            },
        ],
    }

    const bankInfoPopupHide = () => {
        setBankInfoPopupVisible(false)
        dbBankSelectBoxRef.reload()
    }

    const handleSaved = () => {
        if (refreshGrid) {
            setRefreshGrid(false)
            refGrid.current.instance.refresh()
        }
    }

    const handleValidationCallback = (e) =>{
        // console.log("handleValidationCallback-e",e)
        // var iban = e.value.replace(' ','')
        // console.log("iban",iban)
        return IBAN.isValid(e.value)
    }

    useEffect(() => {
        if (isLarge || isMedium)
            setSizeParam({ width: 400, height: 400 })
        else
            setSizeParam({})
    }, [isLarge, isMedium])
    useEffect(() => {
        getLookupData(lookupGroups.bankAccountType).then(respoense => setBankAccountTypeList(respoense))
    }, [])



    return (
        <React.Fragment>
            <div>
                <DataGrid
                    {...getPropsDataGrid}
                    dataSource={dataSource}
                    onInitNewRow={handleInitNewRow}
                    cacheRawData={false}
                    ref={refGrid}
                    onSaved={handleSaved}
                >
                    <Editing {...getPropsDataGridEditing}>
                        <Popup {...getPropsDataGridPopup} title="Kayıt İşlemi" showTitle={true} />
                    </Editing>
                    {getDataGridCustomToolbar("Banka Hesap Bilgileri")}
                    <Column dataField="bankInfoId" caption="Banka Adı" editorType="dxSelectBox" editorOptions={bankInfoEditorOptions}>
                        <FormItem colSpan={2} ></FormItem>
                        <Lookup dataSource={dbBank} valueExpr="id" displayExpr="name" />
                    </Column>
                    <Column dataField="iban" caption="IBAN" editorType="dxTextBox">
                        <FormItem colSpan={2} ></FormItem>
                        <RequiredRule />
                        <CustomRule 
                        validationCallback={handleValidationCallback}
                        />
                        {/* <PatternRule
                            message={'IBAN bu formatta olmalı: TR12 1234 1234 1234 1234 1234 12'}
                            pattern="TR[a-zA-Z0-9]{2}\s?([0-9]{4}\s?){1}([0-9]{1})([a-zA-Z0-9]{3}\s?)([a-zA-Z0-9]{4}\s?){3}([a-zA-Z0-9]{2})\s?"
                        /> */}
                    </Column>

                    <Column dataField="accountTypeId" caption="Hesap Türü" editorType="dxSelectBox" editorOptions={accountTypeEditorOption} >
                        <Lookup dataSource={bankAccountTypeList} valueExpr="id" displayExpr="text" />
                    </Column>

                    <Column dataField="active" caption="Aktif" dataType="boolean" />

                </DataGrid>
                <BankInfoPopup visible={bankInfoPopupVisible} onHide={bankInfoPopupHide} />
            </div>

        </React.Fragment>
    )
}

export default Bank